<template>
    <div class="float-left col text-muted p-item mb-2">
        <small>{{ control.name }}</small><br>
        <template v-if="control.status=='NEW'">
            <img :src="this.currentImage()" alt="" class="added b-2">
        </template>
        <template v-if="control.status=='DELETE'">
            <img :src="this.oldImage()" alt="" class="deleted b-2">
        </template>
        <template v-if="control.status=='UPDATE'">
            <ul>
                <li class="added">
                    <img :src="this.currentImage()" alt="" class="added mb-2 b-2">
                </li>
                <li class="deleted">
                    <img :src="this.oldImage()" alt="" class="deleted b-2">
                </li>
            </ul>
        </template>
    </div>
</template>

<script>
export default {
    name: 'AuditNoteSignatureCapture',

    props: {
        control: Object
    },

    methods: {
        currentImage() {
            let ext = this.control.extension;
            if (!ext) {
                ext = this.control.oldExtension;
            }
            return "data:image/"+ext+";base64,"+this.control.objectContents;
        },

        oldImage() {
            let ext = this.control.oldExtension;
            if (!ext) {
                ext = this.control.extension;
            }
            return "data:image/"+ext+";base64,"+this.control.oldObjectContents;
        }
    }
}
</script>

<style scoped>
.deleted {
    color: red !important;
}
.added {
    color: green !important;
}
.b-2 {
    border: 2px solid !important;
}
</style>